module.exports = __webpack_public_path__ + "img/logo-hermes@2x.46c3cf65.png";